import React, { Component } from "react"
import Header from "../components/header"
import Step from "../components/step"
import "./mystyles.scss"
import Helmet from "react-helmet"
import Player from "../components/videoplayer"
import LearnMore from "../components/learnmore"
import { graphql } from "gatsby"

class LearnPage extends Component {
  chunk(arr, chunkSize) {
    var R = []
    for (var i = 0, len = arr.length; i < len; i += chunkSize)
      R.push(arr.slice(i, i + chunkSize))
    return R
  }

  render(props) {
    let nodes = this.props.data.allLearningItem.edges
      .filter(edge => {
        return edge.node.version === "3.3.0"
      })
      .sort((a, b) => {
        return a.node.ordinal - b.node.ordinal
      })
    let chunks = this.chunk(nodes, 3)
    console.log(chunks)
    return (
      <div className="container">
        <Helmet>
          <script src="https://cdn.jsdelivr.net/npm/hls.js@0.8.2"></script>
        </Helmet>
        <div className="section">
          <div className="level">
            <div className="level-item has-text-centered">
              <img className="header-icon" src="/icons.png" /> &nbsp;&nbsp;{" "}
              <span className="title is-3">
                <b>How to use Spark Camera</b>
              </span>
            </div>
          </div>
        </div>
        <div className="section">
          {chunks.map((value, index) => {
            return (
              <div className="tile is-ancestor">
                {value.map((item, i) => {
                  return (
                    <div className="tile is-parent">
                      <article className="tile is-child has-text-centered">
                        <a href={"/learn/" + item.node.slug}>
                          <img
                            className="center-cropped"
                            src={item.node.thumbnail}
                          />
                          <h1 className="title is-size-4 has-text-white">
                            {item.node.title}
                          </h1>
                        </a>
                      </article>
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export const query = graphql`
  {
    allLearningItem {
      edges {
        node {
          title
          slug
          thumbnail
          version
          ordinal
        }
      }
    }
  }
`

export default LearnPage
